// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tjmo","top":"styles_top__2Rb6Y","left":"styles_left__3uhy3","description":"styles_description__3k03Y"};